import { useState } from "react";
import { useNavigate } from "react-router-dom";

function BookingForm() {

  const [date, setDate] = useState("");
  const [guests, setGuests] = useState(1);
  const [time, setTime] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const availableTimes = ["7:00","8:00","9:00","10:00"];

  function handleSubmit(e) {

    e.preventDefault();

    if (!date) {
      setMessage("Please select a date");
      return;
    }

    if (!time) {
      setMessage("Please select a time");
      return;
    }

    if (guests < 1) {
      setMessage("Guests must be at least 1");
      return;
    }

    setMessage("🎉 Table booked successfully!");
    navigate("/confirmed");
  }

  return (

    <form onSubmit={handleSubmit}>

      <h2>Reserve a Table</h2>

      <label>Select Date</label>

      <input
        type="date"
        value={date}
        onChange={(e)=>setDate(e.target.value)}
      />

      <label>Select Time</label>

      <select
        value={time}
        onChange={(e)=>setTime(e.target.value)}
      >

        <option value="">Choose time</option>

        {availableTimes.map((t)=>(
          <option key={t} value={t}>{t}</option>
        ))}

      </select>

      <label>Number of Guests</label>

      <input
        type="number"
        min="1"
        value={guests}
        onChange={(e)=>setGuests(e.target.value)}
      />

      <button type="submit">
        Reserve
      </button>

      {message && <p>{message}</p>}

    </form>

  );
}

export default BookingForm;